import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import getHasCart from '@core/reducers/cart/selectors/getHasCart';
import getShopInformationPickup from '@shopDetails/selectors/getShopInformationPickup';
import trackTogglePickupClicked from '@shopDetails/tracking/actions/trackTogglePickupClicked';
import updateCartDeliveryType from '@core/reducers/cart/actions/updateCartDeliveryType';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import fetchMenuExtended from '@core/reducers/menu/actions/fetchExtendedMenu';
import getOriginFromUrl from '@core/reducers/shop/selectors/getOriginFromUrl';
import WithPickupToggle from './WithPickupToggle';

const mapStateToProps = createStructuredSelector({
  isPickupSelected: getCartIsPickUp,
  hasCart: getHasCart,
  shopId: getShopId,
  info: getShopInformationPickup,
  origin: getOriginFromUrl,
});

const mapDispatchToProps = {
  updateCartDeliveryType,
  trackTogglePickupClicked,
  fetchMenuExtended,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithPickupToggle);
